import React from 'react';
import { Smartphone, Palette, Brain, Server } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';

const iconMap = {
  Smartphone: Smartphone,
  Palette: Palette,
  Brain: Brain,
  Server: Server,
};

const serviceKeys = ['mobile', 'uiux', 'ai', 'backend'];
const iconKeys = ['Smartphone', 'Palette', 'Brain', 'Server'];

const ServiceCard = ({ serviceKey, iconKey, index, t }) => {
  const IconComponent = iconMap[iconKey];
  const service = t.services.items[serviceKey];
  
  return (
    <div 
      className="group relative bg-[#302f2c] border border-[#1e3a5f]/50 p-8 transition-all duration-300 hover:bg-[#1e3a5f] hover:border-[#7dd3fc]/30"
    >
      {/* Number */}
      <span className="absolute top-6 right-6 text-[#1e3a5f] font-black text-6xl leading-none group-hover:text-[#7dd3fc]/20 transition-colors">
        0{index + 1}
      </span>
      
      {/* Icon */}
      <div className="w-14 h-14 bg-[#1e3a5f] rounded-lg flex items-center justify-center mb-6 group-hover:bg-[#7dd3fc] transition-colors">
        <IconComponent className="w-7 h-7 text-[#7dd3fc] group-hover:text-[#1a1c1b] transition-colors" />
      </div>
      
      {/* Content */}
      <h3 className="text-[#7dd3fc] font-bold text-xl mb-3">
        {service.title}
      </h3>
      <p className="text-[#888680] text-base leading-relaxed group-hover:text-[#7dd3fc]/70 transition-colors">
        {service.description}
      </p>

      {/* Hover accent line */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#7dd3fc] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
    </div>
  );
};

const ServicesSection = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section id="services" className="bg-[#1a1c1b] py-24 md:py-32 relative overflow-hidden">
      {/* Background decorative text */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none">
        <span className="text-[#1e3a5f]/30 font-black uppercase whitespace-nowrap" style={{ fontSize: 'clamp(10rem, 20vw, 25rem)', lineHeight: 0.76 }}>
          Services
        </span>
      </div>

      <div className="max-w-[87.5rem] mx-auto px-10 relative z-10">
        {/* Section Header */}
        <div className="mb-16">
          <span className="text-[#888680] text-sm font-semibold uppercase tracking-widest mb-4 block">
            {t.services.label}
          </span>
          <h2 className="font-black text-[#7dd3fc] uppercase leading-[0.85] mb-6" style={{ fontSize: 'clamp(3rem, 4vw + 1rem, 5.5rem)' }}>
            {t.services.headline}
          </h2>
          <p className="text-[#7dd3fc]/70 text-xl max-w-2xl">
            {t.services.description}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {serviceKeys.map((serviceKey, index) => (
            <ServiceCard 
              key={serviceKey} 
              serviceKey={serviceKey} 
              iconKey={iconKeys[index]}
              index={index} 
              t={t}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
